// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZxsK","col":"styles_col__N09k2"};